import { ResponseErrorHandling } from "../../../../helper";
import commonService from "../../../../services/Common/service";
import { CommonActionTypes } from "../../../action-types";

export const getAllSubAccounts = (data) => async (dispatch) => {
  try {
    const subAccounts = await commonService.post(
      "/user/get-sub-accounts",
      data,
    );

    return subAccounts.data;
  } catch (err) {
    const message = err.response.data.message || err.message;

    ResponseErrorHandling(err.response, dispatch);

    dispatch({
      type: CommonActionTypes.REJECTED,
      payload: { message, isError: true },
    });
  }
};
